export const getNumberOrZero = (value: string | undefined) => {
  const num = Number(value);
  return Number.isNaN(num) ? 0 : num;
};